// extracted by mini-css-extract-plugin
export default {"viewSwitcher":"ViewSwitcher_viewSwitcher__VBr2J","buttons":"ViewSwitcher_buttons__4nzIh","active":"ViewSwitcher_active__50tKx"};